module.exports = __webpack_public_path__ + "img/lateralCover.b1edbea2.png";